import { nonEmptyArray, option } from 'fp-ts';
import { flow } from 'fp-ts/function';
import * as iots from 'io-ts';
import normalizeException from 'normalize-exception';
// -------------------------------------------------------------------------------------------------
// Array
export const arrayMax = (o) => flow(nonEmptyArray.fromArray, option.map(nonEmptyArray.max(o)));
// -------------------------------------------------------------------------------------------------
// io-ts
export const iotsStruct = (required, optional) => iots.intersection([iots.strict(required), iots.exact(iots.partial(optional))]);
export const parseOption = (decoder) => flow(decoder.decode, option.fromEither);
// -------------------------------------------------------------------------------------------------
// Record
export const isNonEmptyRecord = (r) => {
    if (r != null)
        for (const key in r)
            if (Object.prototype.hasOwnProperty.call(r, key))
                return true;
    return false;
};
export const recordKeys = Object.keys;
export const recordValues = Object.values;
// -------------------------------------------------------------------------------------------------
// Task
export const taskRun = (t) => t();
// -------------------------------------------------------------------------------------------------
// String
export const stringJoin = (separator) => ({
    concat: (a, b) => (a === '' || b === '' ? a + b : a + separator + b),
    empty: '',
});
// -------------------------------------------------------------------------------------------------
// invariant
export const fromThrown = normalizeException;
//# sourceMappingURL=prelude.js.map